import React from 'react';
import Dashboard from './components/Dashboard';
import './index.css';

const App: React.FC = () => {
  return <Dashboard />;
};

export default App;
